import {
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';
import { PermissionAction } from 'src/actions/permission.acction';
import { KhophieuAction } from 'src/actions/khophieu.action';

import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    TextField,
    Typography,
    Grid,
    Box,
    Select as Select1,
    InputAdornment,
    SvgIcon,
    MenuItem,
} from '@material-ui/core';

import Select from 'react-select';

import { Search as SearchIcon } from 'react-feather';

import {
    DatePicker,
    LocalizationProvider,
  } from '@mui/x-date-pickers';
  import {
    DEFAULT_ROW_PER_PAGE,
    POST_EDITOR_FONTS,
    POST_EDITOR_FONT_SIZES,
    MAXIMUM_IMAGES,
    MAXIMUM_PRICES,
  } from 'src/utils/constants';
  import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import moment from 'moment';

import PostEditor from "../../components/PostEditor";
import ImageUploader from "../../components/ImageUploader";

const CreateEditDialog = (props) => {
    const dispatch = useDispatch()
    const [selectedPermissionIds, setSelectedPermissionIds] = useState([]);
    const { role } = useSelector(state => state.profile);
    const { selected } = useSelector(state => state.khophieu)

    const [loai_phieu, setLoaiPhieu] = useState("-99");
    const [so_phieu, setSoPhieu] = useState("");
    const [ho_ten_nguoi_nhan, setHoTenNguoiNhan] = useState("");
    const [sdt_nguoi_nhan, setSoDienThoaiNguoiNhan] = useState("");
    const [dia_chi_giao, setDiaChiGiao] = useState("");
    const [ly_do, setLyDo] = useState("");
    const [ten_kho_xuat, setTenKhoXuat] = useState("");
    const [dia_diem_kho_xuat, setDiaDiemKhoXuat] = useState("");
    const [ghi_chu, setGhiChu] = useState("");

    useEffect(() => {
        // 
    }, [])

    useEffect(() => {
        if (props.type === 'EDIT') {
            if (selected) {
                setLoaiPhieu(selected.loai_phieu);
                setSoPhieu(selected.so_phieu);
                setHoTenNguoiNhan(selected.ho_ten_nguoi_nhan);
                setSoDienThoaiNguoiNhan(selected.sdt_nguoi_nhan);
                setDiaChiGiao(selected.dia_chi_giao);
                setLyDo(selected.ly_do);
                setTenKhoXuat(selected.ten_kho_xuat);
                setDiaDiemKhoXuat(selected.dia_diem_kho_xuat);
                setGhiChu(selected.ghi_chu);
            }
        }
    }, [selected])

    const onPressPositive = async () => {
        if (loai_phieu === "-99" ) {
            alert("Vui lòng chọn loại phiếu!");
            return;
        }

        if (so_phieu.trim() === "") {
            alert("Vui lòng nhập số phiếu!");
            return;
        }

        if (ho_ten_nguoi_nhan.trim() === "") {
            alert("Vui lòng nhập họ tên người nhận!");
            return;
        }

        if (sdt_nguoi_nhan.trim() === "") {
            alert("Vui lòng nhập số điện thoại người nhận!");
            return;
        }

        if (dia_chi_giao.trim() === "") {
            alert("Vui lòng nhập địa chỉ giao!");
            return;
        }

        if (ly_do.trim() === "") {
            alert("Vui lòng nhập lý do!");
            return;
        }

        if (ten_kho_xuat.trim() === "") {
            alert("Vui lòng nhập tên kho xuất!");
            return;
        }

        if (dia_diem_kho_xuat.trim() === "") {
            alert("Vui lòng nhập địa điểm kho xuất!");
            return;
        }

        if (props.type === 'EDIT') {
            dispatch(KhophieuAction.update(selected.id, { 
                loai_phieu,
                so_phieu,
                ho_ten_nguoi_nhan,
                sdt_nguoi_nhan,
                dia_chi_giao,
                ly_do,
                ten_kho_xuat,
                dia_diem_kho_xuat,
                ghi_chu,
            }))
            resetState();
            props.handleClose();
        } else {
            try {
                const response = await dispatch(KhophieuAction.create({ 
                    loai_phieu,
                    so_phieu,
                    ho_ten_nguoi_nhan,
                    sdt_nguoi_nhan,
                    dia_chi_giao,
                    ly_do,
                    ten_kho_xuat,
                    dia_diem_kho_xuat,
                    ghi_chu,
                }))
                resetState();
                props.handleClose();
            } catch (error) {
                if (typeof error.code !== 'undefined' && typeof error.msg !== 'undefined') alert("[Lỗi]\n"+error.msg)
            }
        }
    }

    const resetState = () => {
        setLoaiPhieu("-99");
        setSoPhieu("");
        setHoTenNguoiNhan("");
        setSoDienThoaiNguoiNhan("");
        setDiaChiGiao("");
        setLyDo("");
        setTenKhoXuat("");
        setDiaDiemKhoXuat("");
        setGhiChu("");
    }

    const handleSelectOne = (event, id) => {
        const selectedIndex = selectedPermissionIds.indexOf(id);
        let newSelectedCustomerIds = [];
        if (selectedIndex === -1) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(selectedPermissionIds, id);
        } else if (selectedIndex === 0) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(selectedPermissionIds.slice(1));
        } else if (selectedIndex === selectedPermissionIds.length - 1) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(selectedPermissionIds.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(
                selectedPermissionIds.slice(0, selectedIndex),
                selectedPermissionIds.slice(selectedIndex + 1)
            );
        }
        setSelectedPermissionIds(newSelectedCustomerIds);
    };

    const setColor = (value) => {
        if (value == 'cho_duyet') return 'orange';
        else if (value == 'da_duyet') return 'green';
        else if (value == 'tu_choi') return 'red';
        else if (value == 'positive') return 'green';
        else if (value == 'negative') return 'red';
        else return '#000000';
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Dialog className='modal-content-no-scroll' open={props.open} onClose={props.handleClose}>
                <DialogTitle>{props.type === 'EDIT' ? "Cập nhật bản ghi" : "Tạo bản ghi mới"}</DialogTitle>
                <DialogContent className='modal-content-no-scroll' style={{ width: 600, paddingTop: 20 }}>
                    <Grid
                        container
                        spacing={3}
                    >
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <Select1
                                style={{ height: 56, marginTop: 0, marginBottom: 0, width: "100%", marginLeft: 0 }}
                                name="loai_phieu"
                                value={loai_phieu || -99}
                                onChange={(e) => setLoaiPhieu(e.target.value)}
                                variant="outlined"
                                startAdornment={(
                                <InputAdornment position="start">
                                    <SvgIcon fontSize="small" color="action">
                                        <SearchIcon />
                                    </SvgIcon>
                                </InputAdornment>
                                )}
                            >
                                <MenuItem value="-99">Loại phiếu...</MenuItem>
                                <MenuItem style={{ color: setColor('nhap_kho') }} value="nhap_kho">Nhập kho</MenuItem>
                                <MenuItem style={{ color: setColor('xuat_kho') }} value="xuat_kho">Xuất kho</MenuItem>
                            </Select1>
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <TextField
                                fullWidth
                                label="Số phiếu"
                                name="so_phieu"
                                onChange={(e) => setSoPhieu(e.target.value)}
                                required
                                value={so_phieu}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <TextField
                                fullWidth
                                label="Họ tên người nhận"
                                name="ho_ten_nguoi_nhan"
                                onChange={(e) => setHoTenNguoiNhan(e.target.value)}
                                required
                                value={ho_ten_nguoi_nhan}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <TextField
                                fullWidth
                                label="Số điện thoại người nhận"
                                name="sdt_nguoi_nhan"
                                onChange={(e) => setSoDienThoaiNguoiNhan(e.target.value)}
                                required
                                value={sdt_nguoi_nhan}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <TextField
                                fullWidth
                                label="Địa chỉ giao"
                                name="dia_chi_giao"
                                onChange={(e) => setDiaChiGiao(e.target.value)}
                                required
                                value={dia_chi_giao}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <TextField
                                fullWidth
                                label="Lý do"
                                name="ly_do"
                                onChange={(e) => setLyDo(e.target.value)}
                                required
                                value={ly_do}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <TextField
                                fullWidth
                                label="Tên kho xuất"
                                name="ten_kho_xuat"
                                onChange={(e) => setTenKhoXuat(e.target.value)}
                                required
                                value={ten_kho_xuat}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <TextField
                                fullWidth
                                label="Địa điểm kho xuất"
                                name="dia_diem_kho_xuat"
                                onChange={(e) => setDiaDiemKhoXuat(e.target.value)}
                                required
                                value={dia_diem_kho_xuat}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={6}
                        >
                            <TextField
                                fullWidth
                                label="Ghi chú"
                                name="ghi_chu"
                                onChange={(e) => setGhiChu(e.target.value)}
                                value={ghi_chu}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.handleClose}>Huỷ</Button>
                    <Button onClick={onPressPositive}>{props.type === 'EDIT' ? "Cập nhật" : "Tạo"}</Button>
                </DialogActions>
            </Dialog >
        </LocalizationProvider>
    );
}

export default CreateEditDialog;